import { JsonFormsDispatch, withJsonFormsLayoutProps } from "@jsonforms/react";
import { Divider } from "pepsico-ds";
import "./layer-layout.scss";

const LayerLayout = ({ schema, uischema, path, renderers, cells, enabled }) => {
  return (
    <div className="display-flex flex-direction-column gap-2">
      {uischema.label && <span className="font-xsmall-caps">{uischema.label}</span>}
      <div className="layer-layout">
        {uischema.elements.map((element, index) => (
          <>
            <JsonFormsDispatch
              schema={schema}
              uischema={element}
              path={path}
              enabled={enabled}
              renderers={renderers}
              cells={cells}
              key={index}
            />
            {index < uischema.elements.length - 1 && (
              <Divider orientation="horizontal" className="mt-1 mb-3" />
            )}
          </>
        ))}
      </div>
    </div>
  );
};

export const LayerLayoutControl = withJsonFormsLayoutProps(LayerLayout);
